/// <reference path="../types/everflow-sdk.d.ts"/>
import EverflowSDK from '@everflow/everflow-sdk'
import { getCookieDomain } from '@/utils/cookie'
import { serializeParameters } from '@/utils/general'
import {
  EverflowClientAffiliateIDToken,
  EverflowClientOfferIDToken,
  EverflowClientCookie,
  EverflowClientSubIDCookie,
  EFTransactionIDToken,
  EverflowClientSourceIDCookie,
  EverflowClientAffiliateIDCookie
} from '@/enums/gtm'

export default ({ app, route }) => {
  const efcAffiliateIDToken = route.query[EverflowClientAffiliateIDToken]
  const efcOfferIDToken = route.query[EverflowClientOfferIDToken]
  const EFCTransactionIDToken = route.query[EFTransactionIDToken]

  const sourceId = route.query.source_id

  const subIds = {
    adv_event_id: route.query.adv_event_id,
    sub1: route.query.sub1,
    sub2: route.query.sub2,
    sub3: route.query.sub3,
    sub4: route.query.sub4,
    sub5: route.query.sub5
  }

  const serializedParameters = serializeParameters(subIds)

  if (serializedParameters) {
    app.$cookies.set(EverflowClientSubIDCookie, serializeParameters(subIds), { expires: new Date(Date.now() + 604800), path: '/', domain: getCookieDomain() })
  }

  if (sourceId) {
    app.$cookies.set(EverflowClientSourceIDCookie, sourceId, { expires: new Date(Date.now() + 604800), path: '/', domain: getCookieDomain() })
  }

  if (efcAffiliateIDToken) {
    app.$cookies.set(EverflowClientAffiliateIDCookie, efcAffiliateIDToken, { expires: new Date(Date.now() + 604800), path: '/', domain: getCookieDomain() })
  }

  if (efcAffiliateIDToken || EFCTransactionIDToken) {
    try {
      EverflowSDK.configure({
        tracking_domain: 'https://www.onthatass-deals.com'
      })

      EverflowSDK.click({
        offer_id: `${efcOfferIDToken}`,
        affiliate_id: `${efcAffiliateIDToken}`,
        sub1: EverflowSDK.urlParameter('sub1'),
        sub2: EverflowSDK.urlParameter('sub2'),
        sub3: EverflowSDK.urlParameter('sub3'),
        sub4: EverflowSDK.urlParameter('sub4'),
        sub5: EverflowSDK.urlParameter('sub5'),
        source_id: EverflowSDK.urlParameter('source_id'),
        transaction_id: EFCTransactionIDToken
      }).then((transactionID) => {
        app.$cookies.set(EverflowClientCookie, transactionID, { expires: new Date(Date.now() + 604800), path: '/', domain: getCookieDomain() })
      }).catch((error) => {
        app.$ota.general.logError(error)
      })
    } catch (error) {
      app.$ota.general.logError(error)
    }
  }
}
